<template>
  <div class="three-text"></div>
</template>

<script>
import { MeshPhongMaterial, TextGeometry, BufferGeometry, Mesh, Font } from 'three'
import axios from 'axios'
import Object3DMixin from '@/components/threejs/objects/Object3DMixin'

export default {
  name: 'ThreeText',
  mixins: [Object3DMixin],
  created () {
    const materials = [
      new MeshPhongMaterial({ color: this.node.colour, flatShading: true }), // front
      new MeshPhongMaterial({ color: this.node.colour }) // side
    ]

    this.loadFont()
      .then(font => {
        const text = this.createText(this.node.text, font, materials, this.node.width, this.node.depth)
        this.object3d.add(text)
        this.$emit('loaded', this.node)
      })
  },
  methods: {
    loadFont () {
      return axios.get(`/fonts/${this.node.font}.json`)
        .then(({ data }) => new Font(data))
    },
    createText (text, font, materials, size, height, curveSegments = 4, bevelThickness = 0.08, bevelSize = 0.03, bevelEnabled = true) {
      let textGeo = new TextGeometry(text, {
        font: font,
        size: size,
        height: height,
        curveSegments: curveSegments,
        bevelThickness: bevelThickness,
        bevelSize: bevelSize,
        bevelEnabled: bevelEnabled
      })

      textGeo.computeBoundingBox()
      textGeo.computeVertexNormals()
      textGeo = new BufferGeometry().fromGeometry(textGeo)
      return new Mesh(textGeo, materials)
    }
  }
}
</script>

<style>

</style>
